import '../styles/ffc.scss'
import 'babel-polyfill'
import smoothscroll from 'smoothscroll-polyfill';
import Theme from './Theme'

smoothscroll.polyfill();

let theme = new Theme()
theme.mountComponents()

document.addEventListener('shopify:section:unload', e => {
  theme.unmountComponents(e.target)
})

document.addEventListener('shopify:section:load', e => {
  theme.mountComponents(e.target)
})